import { Box, Link, Typography, useTheme } from '@mui/material';
import AppLogoImage from '../../assets/images/repraise-logo.png';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';

interface Props {
  privacyPolicyLink: string;
  imprintLink: string;
  company: string;
}

const SurveyFooter: FC<Props> = ({ privacyPolicyLink, imprintLink, company }) => {
  const theme = useTheme();

  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation('customSurvey');
  const t = localContext ? localContext.t : globalT;

  const useSpaceBetween = imprintLink || privacyPolicyLink;

  return (
    <Box
      className="survey-footer"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: 'auto',
      }}
    >
      <Box
        className="survey-footer-content"
        sx={{
          display: 'flex',
          justifyContent: useSpaceBetween ? 'space-between' : 'space-between',
          alignItems: 'center',
          gap: theme.spacing(1),
          minWidth: 'auto',
          maxWidth: '85.375rem',
          width: '100%',
          borderTop: `1px solid ${theme.palette.divider}`,
          px: theme.spacing(3),
          py: theme.spacing(2),
        }}
      >
        {company && (
          <Typography variant="caption">
            &#169;{` ${new Date().getFullYear()} ${company}`}
          </Typography>
        )}
        <Box
          className="survey-footer-links"
          sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1), flexWrap: 'wrap' }}
        >
          {imprintLink && (
            <Link
              className="survey-footer-link survey-footer-link--imprint"
              variant="caption"
              href={imprintLink}
              underline="none"
              target="_blank"
              rel="noreferrer"
            >
              {t('imprint')}
            </Link>
          )}
          {imprintLink && privacyPolicyLink && <Typography variant="caption">|</Typography>}
          {privacyPolicyLink && (
            <Link
              className="survey-footer-link survey-footer-link--privacy"
              variant="caption"
              href={privacyPolicyLink}
              underline="none"
              target="_blank"
              rel="noreferrer"
            >
              {t('privacy')}
            </Link>
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: theme.spacing(1) }}>
          <Typography variant="caption">Powered by:</Typography>
          <Link
            variant="caption"
            href="https://repraise.ai/"
            underline="none"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={AppLogoImage}
              style={{
                maxHeight: theme.spacing(2.5),
              }}
              alt={t('app_logo_alt')}
            />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default SurveyFooter;
